import { articles } from "@/mocks/articles";
import ArticleCard from "@/components/feature/ArticleCard";
import SectionHeading from "@/components/feature/SectionHeading";

export default function HotGrid() {
  const hot = articles.filter((a) => a.slug !== articles[0].slug).slice(0, 6);

  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto max-w-[1240px] px-4 py-8 md:px-6 md:py-10">
        <SectionHeading
          title="热门爆料"
          subtitle="被转发最多、讨论最热的瓜都在这里"
          icon="ri-fire-line"
          moreTo="/category/star"
          moreLabel="更多爆料"
        />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {hot.map((a) => (
            <ArticleCard key={a.slug} article={a} />
          ))}
        </div>
      </div>
    </section>
  );
}